import { useState } from "react";
import { useCreateFeatureMutation } from "../hooks/useFeatureRequestsQueries";
import { errorMessage } from "../utils";
import DSDialog from "../../system-design/DSDialog";
import DSDialogTitle from "../../system-design/DSDialogTitle";
import DSDialogContent from "../../system-design/DSDialogContent";
import DSDialogActions from "../../system-design/DSDialogActions";
import DSTextField from "../../system-design/DSTextField";
import DSPrimaryButton from "../../system-design/DSPrimaryButton";
import DSSecondaryButton from "../../system-design/DSSecondaryButton";
import DSAlert from "../../system-design/DSAlert";
import DSBox from "../../system-design/DSBox";

const NewFeatureModal = (props: { open: boolean; onClose: () => void }) => {
  const createFeature = useCreateFeatureMutation();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const onEnter = () => {
    setTitle("");
    setDescription("");
    createFeature.reset();
  };

  return (
    <DSDialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
      maxWidth="sm"
      TransitionProps={{ onEnter }}
    >
      <DSDialogTitle>New feature</DSDialogTitle>
      <DSDialogContent>
        <DSBox sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          <DSTextField
            label="Title"
            required
            autoFocus
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <DSTextField
            label="Description (optional)"
            multiline
            minRows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          {createFeature.isError && (
            <DSAlert severity="error">
              {errorMessage(createFeature.error, "Failed to create feature.")}
            </DSAlert>
          )}
        </DSBox>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={props.onClose}>Cancel</DSSecondaryButton>
        <DSPrimaryButton
          disabled={!title.trim() || createFeature.isPending}
          onClick={() =>
            createFeature.mutate(
              {
                title: title.trim(),
                description: description.trim() || null,
              },
              { onSuccess: props.onClose },
            )
          }
        >
          Create
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default NewFeatureModal;
